export function mostrarIngestaJatsa({ planillaCerrada, enabled }) {
  return Boolean(planillaCerrada && enabled);
}

export function mostrarConexionJatsa(enabled) {
  return Boolean(enabled);
}

export function mensajeCierreJatsa(enabled) {
  if (!mostrarConexionJatsa(enabled)) {
    return "";
  }
  return "Se enviará esta planilla al módulo Jatsa.";
}

export function mensajeReaperturaJatsa(enabled) {
  if (!mostrarConexionJatsa(enabled)) {
    return "";
  }
  return "Se pedirá borrar esta planilla en el módulo Jatsa y se quitarán de PLAME los conceptos que trajo el satélite.";
}

export function mensajeReenvioJatsa(ok) {
  if (ok) {
    return "Se reenviará esta planilla al módulo Jatsa.";
  }
  return "No se pudo reenviar al módulo Jatsa.";
}

export function anexarMensajeJatsa(base, extra) {
  const principal = String(base || "").trim();
  const agregado = String(extra || "").trim();
  if (!agregado) {
    return principal;
  }
  if (!principal) {
    return agregado;
  }
  return `${principal}\n\n${agregado}`;
}

export function tituloPeticionJatsa(item) {
  return String(item?.titulo || "Petición Jatsa");
}

export function mensajePeticionJatsa(item) {
  const partes = [];
  if (item?.status_http) {
    partes.push(`HTTP ${item.status_http}`);
  }
  const jatsaId = item?.request_resumen?.jatsa_id;
  if (jatsaId) {
    partes.push(String(jatsaId));
  }
  if (item?.request_resumen?.trabajadores != null) {
    partes.push(`${item.request_resumen.trabajadores} duales`);
  }
  const base = String(item?.mensaje || "").trim();
  if (partes.length === 0) {
    return base;
  }
  return base ? `${base} (${partes.join(" · ")})` : partes.join(" · ");
}

export function peticionJatsaExitosa(item) {
  return Boolean(item?.ok) || Boolean(item?.omitido);
}

export function etiquetaEstadoJatsa(estado) {
  const valor = String(estado || "").toLowerCase();
  if (valor === "enviado") {
    return "Enviado a Jatsa";
  }
  if (valor === "error") {
    return "Error al enviar a Jatsa";
  }
  if (valor === "pendiente") {
    return "Envío a Jatsa pendiente";
  }
  if (valor === "omitido") {
    return "Envío a Jatsa omitido";
  }
  return "Sin envío a Jatsa";
}

export function etiquetaConceptosPlameJatsa(estado) {
  const valor = String(estado || "").toLowerCase();
  if (valor === "aplicado") {
    return "Conceptos Jatsa en PLAME";
  }
  if (valor === "disponible") {
    return "Jatsa tiene conceptos listos";
  }
  if (valor === "pendiente") {
    return "Jatsa aún no envió a planillas";
  }
  if (valor === "error") {
    return "Error al leer conceptos Jatsa";
  }
  return "Sin conceptos Jatsa";
}

export const CLAVE_AUTO_RECERRAR_JATSA = "jatsa_auto_recerrar_planilla";
export const CLAVE_AUTO_RECERRAR_MOTIVO_JATSA = "jatsa_auto_recerrar_motivo";

export function marcarAutoRecerrarJatsa(planillaId, motivo = "aplicar") {
  try {
    sessionStorage.setItem(CLAVE_AUTO_RECERRAR_JATSA, String(planillaId));
    sessionStorage.setItem(CLAVE_AUTO_RECERRAR_MOTIVO_JATSA, String(motivo || "aplicar"));
  } catch (_) {
    // sessionStorage no disponible
  }
}

export function debeAutoRecerrarJatsa(planillaId) {
  try {
    return sessionStorage.getItem(CLAVE_AUTO_RECERRAR_JATSA) === String(planillaId);
  } catch (_) {
    return false;
  }
}

export function motivoAutoRecerrarJatsa() {
  try {
    return String(sessionStorage.getItem(CLAVE_AUTO_RECERRAR_MOTIVO_JATSA) || "aplicar");
  } catch (_) {
    return "aplicar";
  }
}

export function limpiarAutoRecerrarJatsa() {
  try {
    sessionStorage.removeItem(CLAVE_AUTO_RECERRAR_JATSA);
    sessionStorage.removeItem(CLAVE_AUTO_RECERRAR_MOTIVO_JATSA);
  } catch (_) {
    // sessionStorage no disponible
  }
}

export function mensajeAplicarConceptosJatsa(ok, _reabrir) {
  if (!ok) {
    return "Jatsa aún no publicó conceptos PLAME. No se aplican ceros.";
  }
  return "Conceptos de Jatsa cargados en PLAME. Se recalcula AFP/ESSALUD/IR y se vuelve a cerrar sin retirar de Jatsa.";
}

export function mensajeRevertirJatsa(ok) {
  if (!ok) {
    return "No se pudo revertir la sincronización con Jatsa.";
  }
  return "Se revirtió la sincronización con Jatsa. Se recalcan los conceptos originales y se vuelve a cerrar sin reenviar.";
}

export function urlFichaCerradaJatsa(periodo, baseUrl) {
  const mes = String(periodo || "").trim();
  if (!/^\d{4}-\d{2}$/.test(mes)) {
    return "";
  }
  const base = String(baseUrl || "").replace(/\/+$/, "");
  if (base === "") {
    return "";
  }
  return `${base}/planillas-cerradas/cerrada-${mes}`;
}

export function urlFichaCerradaJatsaConSesion(periodo, baseUrl, token) {
  const href = urlFichaCerradaJatsa(periodo, baseUrl);
  const sesion = String(token || "").trim();
  if (!href || sesion === "") {
    return href;
  }
  return `${href}#access_token=${encodeURIComponent(sesion)}`;
}

export function inspeccionDesdeRespuestaConceptosJatsa(respuesta) {
  const data = respuesta?.data || {};
  return {
    consultadoEn: new Date().toLocaleString(),
    disponible: respuesta?.disponible,
    jatsa_http_status: data.jatsa_http_status ?? null,
    jatsa_api: data.jatsa_api ?? null,
    paquete_plame: data.paquete_plame ?? null,
    vista_empleados: data.vista_empleados ?? null,
    resumen: {
      trabajadores: data.trabajadores,
      conceptos: data.conceptos,
      jatsa_id: data.jatsa_id,
      periodo: data.periodo,
      enviado_en: data.enviado_en,
    },
  };
}

export function haySincronizacionJatsaParaRevertir({ estado, conceptosEstado } = {}) {
  const envio = String(estado || "").toLowerCase();
  const conceptos = String(conceptosEstado || "").toLowerCase();
  if (["enviado", "pendiente", "error"].includes(envio)) {
    return true;
  }
  return ["aplicado", "disponible", "error"].includes(conceptos);
}
